import polylabel from 'polylabel';
import type { MapPoint, MapRenderFieldLabelModel } from '../types';

/**
 * Resolves a field label anchor via the polygon pole of inaccessibility and API shifts.
 *
 * @param params Polygon vertices and page-provided label settings; offsets are applied after `polylabel`.
 * @returns New unrounded SVG text-anchor coordinates in map coordinate units.
 */
export function resolveFieldLabelAnchor(params: {
  points: readonly MapPoint[];
  label: MapRenderFieldLabelModel;
}): MapPoint {
  const polygon = [params.points.map((point): [number, number] => [point.x, point.y])];
  const [anchorX, anchorY] = polylabel(polygon, 1);

  return {
    x: anchorX + params.label.shiftX,
    y: anchorY + params.label.shiftY,
  };
}
